import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AchievementRoute, Achievement, RouteOptions, AchievementDynamic } from '../../../../api/interfaces/register';
import { DateAdapter } from '@angular/material/core';
import { SharedDataService } from '../../../../services/sharedData/shared-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { FormValidatorService } from '../../../../services/formValidator/form-validator.service';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service'
import { ActivatedRoute } from '@angular/router';
import { FilterDataService } from 'src/app/services/filterData/filter-data.service';
import { AntecedentesEnum } from 'src/app/enums/antecedentes';
import { GenericDialogComponent } from 'src/app/components/generic-dialog/generic-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LocalAuxData } from 'src/app/api/interfaces/user';

@Component({
  selector: 'app-achievements',
  templateUrl: './achievements.component.html',
  styleUrls: ['./achievements.component.scss']
})
export class AchievementsComponent implements OnInit, OnDestroy {

  achievements: Achievement[] = [];
  achievementsRoute: AchievementRoute[] = [];
  routeOptions: RouteOptions[] = [];

  achievementsForm = new FormGroup({
    distance: new FormControl(),
    time: new FormControl(),
    date: new FormControl(),
    type: new FormControl()
  });

  achievementsRouteForm = new FormGroup({
    type: new FormControl(),
    id: new FormControl(),
    time: new FormControl(),
    date: new FormControl(),
  });

  flag: string = "";
  isRuta: boolean = false;
  isMobile: boolean = false;
  isRegistration: boolean = false;


  private sharedData$: Subscription;

  @Input('route') achievementsRouteForEdit?: AchievementDynamic[];
  @Input('achievement') achievementsForEdit?: AchievementDynamic[];
  @Input('edit') edit?: boolean;
  @Input('mode') mode?: string;
  @Input('disable') disable?: boolean;
  @Output() changeAchievementEvent: EventEmitter<any> = new EventEmitter();
  @Output() emptyAchievementEvent = new EventEmitter<string>();

  constructor(
    private _adapter: DateAdapter<any>,
    private sharedData: SharedDataService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private formValidatorService: FormValidatorService,
    private mobileDetectorService: MobileDetectorService,
    private router: ActivatedRoute,
    private filterData: FilterDataService,
    public dialog: MatDialog,
  ) {
    this.matIconRegistry.addSvgIcon(
      `delete`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../../assets/delete.svg')
    );
  }

  ngOnInit(): void {
    const auxDelete: string = "localAuxData" + this.mode;
    sessionStorage.removeItem(auxDelete);
    this.isMobile = this.mobileDetectorService.isMobile();
    const url = this.router.snapshot.routeConfig.path;
    if (url == "registration") {
      this.isRegistration = true;
    }
    if (this.mode === "ruta") {
      this.isRuta = true;
    }
    if (!this.edit) {
      this.addAchievement();
    }
    this._adapter.setLocale('es');
    this.sharedData$ = this.sharedData.currentMessage.subscribe(message => {
      this.flag = message
      if (message === "saveStep3") {
        this.saveAchievement();
      }
    });
  }

  removeAchievement(i) {
    if (i >= 0) {
      if (!this.isRuta) {
        this.achievements.splice(i, 1);
      } else {
        this.achievementsRoute.splice(i, 1);
      }
      this.checkLength();
    }
    this.changeValidInput();
  }

  removeAchievementFromEdit(i: number) {

    // const dialogRef = this.dialog.open(GenericDialogComponent, {
    //   data: {
    //     title: "¿Está seguro que desea eliminar la marca?",
    //     iconClass: "bigBlueIcon",
    //     text: "",
    //     icon: "error_outlined",
    //     confirm: "ELIMINAR",
    //     cancel: "NO"
    //   }
    // });
    
    // dialogRef.afterClosed().subscribe(result => {
    //   if(result) {
      // debugger
        if (i >= 0) {
          if (!this.isRuta) {
            if (this.achievementsForEdit[i].activo) {
              this.achievementsForEdit[i].activo = false;
              if(this.achievementsForEdit[i].id == null) {
                this.achievementsForEdit.splice(i, 1);
              }
            } else {
              this.achievementsForEdit.splice(i, 1);
            }
          } else {
            if (this.achievementsRouteForEdit[i].activo) {
              this.achievementsRouteForEdit[i].activo = false;
            } else {
              this.achievementsRouteForEdit.splice(i, 1);
            }
          }
          // this.checkLength();
        }
        this.sharedData.changeMessage("remove");
        this.changeValidInputEdit();
    //   }
    // });
  }

  checkLength() {
    if (this.mode === "ruta") {
      if (this.achievementsRoute.length == 0) {
        this.emptyAchievementEvent.emit(this.mode);
      }
    } else {
      if (this.achievements.length == 0) {
        this.emptyAchievementEvent.emit(this.mode);
      }
    }
  }
  
  addAchievement() {
    this.changeAchievement(false);
    // debugger
    if (!this.isRuta) {
      if(!this.isRegistration) {
        this.achievementsForEdit.push({fechaMarca: "", tiempoMarcaMinutos: 0, tiempoMarcaSegundos: 0, tiempoMarcaHoras: 0, antecedentePreguntaDetalleId: 0, activo: true, id: null, valid: false  });
        this.changeValidInputEdit();
      } else {
        this.achievements.push({ distance: null, time: null, date: new Date(""), valid: false, id: null });
      }
    } else {
      if(!this.isRegistration) {
        this.achievementsRouteForEdit.push({ fechaMarca: "", tiempoMarcaMinutos: 0, tiempoMarcaSegundos: 0, tiempoMarcaHoras: 0, antecedentePreguntaDetalleId: AntecedentesEnum.RUTA, activo: true, id: null, valid: false  });
        this.changeValidInputEdit();
      } else {
      this.achievementsRoute.push({ routeType: { distanciaTipoId: null, distanciaDescripcion: null }, time: null, date: new Date(""), valid: false, id: null });
      }
    }
  }

  saveAchievementRouteFromInputComponentFromEdit(achievement) {
    if(this.checkValidTime(achievement)) {
      if (achievement.type && achievement.type.id) {

        const aux: AchievementDynamic = this.filterData.completeAchievement(achievement, this.mode, true);
        
        //bugfix
        let index: number = -1;
        if(aux.id) {
          index = this.achievementsRouteForEdit.findIndex(ach => ach.id == aux.id);
        } else {
          index = achievement.i;
        }

        if (index != -1) {
          this.achievementsRouteForEdit[index].tiempoMarcaHoras = aux.tiempoMarcaHoras,
          this.achievementsRouteForEdit[index].tiempoMarcaMinutos = aux.tiempoMarcaMinutos,
          this.achievementsRouteForEdit[index].tiempoMarcaSegundos = aux.tiempoMarcaSegundos,
          this.achievementsRouteForEdit[index].distanciaTipoId = aux.distanciaTipoId,
          this.achievementsRouteForEdit[index].fechaMarca = aux.fechaMarca;
          // ticket 2457
          const tiempoNoNulo: boolean = aux.tiempoMarcaHoras + aux.tiempoMarcaMinutos + aux.tiempoMarcaSegundos > 0;
          if( tiempoNoNulo) {
            this.achievementsRouteForEdit[index].valid = true;
          } else {
            this.achievementsRouteForEdit[index].valid = false;
          }
        } else {
          // this.achievementsForEdit.push(aux);
        }
      }
    } else {

    }

    this.changeValidInputEdit();
  }

  saveAchievementFromInputComponentFromEdit(achievement) {
    if(this.checkValidTime(achievement)) {
      if( (achievement.distance || achievement.distance == '' || achievement.distance == null) ) {
        const aux: AchievementDynamic =  this.filterData.completeAchievement(achievement, this.mode,true);

        //bugfix
        let index: number = -1;
        if(aux.id) {
          index = this.achievementsForEdit.findIndex(ach => ach.id == aux.id);
        } else {
          index = achievement.i;
        }

        if(index != -1) {
          this.achievementsForEdit[index].distanciaMarca = aux.distanciaMarca;
          this.achievementsForEdit[index].tiempoMarcaHoras = aux.tiempoMarcaHoras;
          this.achievementsForEdit[index].tiempoMarcaMinutos = aux.tiempoMarcaMinutos;
          this.achievementsForEdit[index].tiempoMarcaSegundos = aux.tiempoMarcaSegundos;
          this.achievementsForEdit[index].fechaMarca = aux.fechaMarca;
          this.achievementsForEdit[index].antecedentePreguntaDetalleId = aux.antecedentePreguntaDetalleId;
          // ticket 2389
          const distanciaValida: boolean = ( aux.distanciaMarca != null && aux.distanciaMarca != undefined && aux.distanciaMarca != "");
          // ticket 2457
          const tiempoNoNulo: boolean = (aux.tiempoMarcaHoras + aux.tiempoMarcaMinutos + aux.tiempoMarcaSegundos) > 0;
          if( tiempoNoNulo && distanciaValida ) {
            this.achievementsForEdit[index].valid = true;
          } else {
            this.achievementsForEdit[index].valid = false;
          }
        } else {
          // this.achievementsForEdit.push(aux);
        }
      }
    } else {
      this.setUnvalid(achievement);
    }
    this.changeValidInputEdit();
  }

  setUnvalid(achievement) {
    let index = this.achievementsForEdit.findIndex(ach => ach.id == achievement.id);
    this.achievementsForEdit[index].valid = false;
  }

  checkValidTime(achievement): boolean {
    let result: boolean = false;
    if(achievement.time) {
      if(achievement.time.length > 0 && achievement.time != "00:00:00") {
        result = true;
      } else {
        result = false;
      }
    }
    return result;
  }

  saveAchievementFromInputComponent(achievement) {
    // ticket 2457
    const timeValid: boolean = (achievement.time.length == 6 && achievement.time != '000000');
    if (achievement.distance != null) {
      let position = this.achievements[achievement.i];
      position.distance = achievement.distance;
      position.time = achievement.time;
      position.date = achievement.date ? achievement.date : "";
      if (!timeValid || achievement.distance === '' || achievement.distance === null  ) {
        position.valid = false;
      } else {
        position.valid = true;
      }
    } else {
      let position = this.achievementsRoute[achievement.i];
      position.time = achievement.time;
      position.date = achievement.date ? achievement.date : "";
      position.routeType = achievement.type;
      if (!timeValid || achievement.type === '' || achievement.type === null) {
        position.valid = false;
      } else {
        position.valid = true;
      }
    }
    this.changeValidInput();
  }

  checkEntrys(): boolean {
    let contador: number = 0;
    let length: number = 0;
    let contadorRuta: number = 0;
    let lengthRuta: number = 0;

    if(this.achievementsForEdit) {
      if(this.achievementsForEdit.length > 0) {
        length = this.achievementsForEdit.length;
        this.achievementsForEdit.forEach(objetive => {
          if (objetive.valid) {
            contador++;
          }
        });
      }
    }

    if(this.achievementsRouteForEdit) {
      if(this.achievementsRouteForEdit.length > 0) {
        lengthRuta = this.achievementsRouteForEdit.length;
        this.achievementsRouteForEdit.forEach(objetive => {
          if (objetive.valid) {
            contadorRuta++;
          }
        });
      }
    }
    let valid: boolean = contador === length && contadorRuta == lengthRuta;
    const aux: LocalAuxData = {
      valid: valid,
      mode: this.mode
    };
    const nombre: string = "localAuxData" + this.mode;
    sessionStorage.setItem(nombre,JSON.stringify(aux));
    return (valid);
  }

  changeValidInputEdit() {

    if (this.checkEntrys()) {
      this.sharedData.changeMessage("achievementsValid");
    } else {
      this.sharedData.changeMessage("achievementsInvalid");
    }
  }

  changeValidInput() {

    // debugger

    let contador = 0;
    let length = 0;
    if (!this.isRuta) {
      length = this.achievements.length;
      this.achievements.forEach(objetive => {
        if (objetive.valid) {
          contador++;
        }
      });
    } else {
      length = this.achievementsRoute.length;
      this.achievementsRoute.forEach(objetive => {
        if (objetive.valid) {
          contador++;
        }
      });
    }
    if (contador === length) {
      this.changeAchievement(true);
    } else {
      this.changeAchievement(false);
    }
  }

  changeAchievement(valid: boolean) {
    let aux = {
      valid: valid,
      mode: this.mode
    };
    // debugger
    this.changeAchievementEvent.emit(aux);
  }

  saveAchievement() {
    let aux;
    if (!this.isRuta) {
      aux = this.achievements;
    } else {
      aux = this.achievementsRoute;
    }
    sessionStorage.setItem(this.mode, JSON.stringify(aux));
  }

  deleteAchievement() {
    sessionStorage.removeItem(this.mode);
  }

  public ngOnDestroy(): void {
    this.sharedData$.unsubscribe();
  }
}